import React from "react";

/**
 * Button Component
 * Reusable button with consistent styling matching original CSS
 * 
 * @param {string} variant - Button variant (primary, secondary, success)
 * @param {string} type - Button type (button, submit)
 * @param {function} onClick - Click handler
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional classes
 * @param {ReactNode} children - Button content
 */
const Button = ({
  variant = "primary",
  type = "button",
  onClick,
  disabled = false,
  className = "",
  children,
  ...props
}) => {
  const variantStyles = {
    primary: "bg-[#3901ff] text-white hover:bg-[#3001dd]",
    secondary: "bg-gray-200 text-[#2b2b2b] hover:bg-gray-300",
    success: "bg-[#2cc26a] text-[#f9f9f9] hover:bg-[#28b05f]",
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`rounded-[0.3rem] font-roboto font-normal transition-colors ${
        variantStyles[variant]
      } ${disabled ? "opacity-50 cursor-not-allowed" : ""} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
